import { pageInfo, uploadImport, unloadDelete } from '../api';
import { plant } from '../../../../../api'
const unloadOrder = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: [],
    importDataObj:null,
    deleteObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = (data.obj || []).map(item => ({ key: item.plantName, value: item.plantCode }))
    },
    UPLOAD_IMPORT(state, data) {
      state.importDataObj = data;
    },
    UPLOAD_DELETE(state, data) {
      state.deleteObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async uploadImport({commit}, obj) {
      let resp = await uploadImport(obj);
      commit('UPLOAD_IMPORT', resp);
    },
    async unloadDelete({commit}, obj) {
      let resp = await unloadDelete(obj);
      commit('UPLOAD_DELETE', resp);
    },
  }
}
export default unloadOrder



// WEBPACK FOOTER //
// ./src/page/bd/accessory/unloadOrder/store/unloadOrder.store.js